import { useSelector } from 'react-redux';
import { getLicensedProducts } from 'features/Auth/auth';

const useLicensedProducts = () => {
  const lps = useSelector(getLicensedProducts);

  return {
    hasCore: lps?.core,
    hasLedger: lps?.ledger,
    hasWarehouse: lps?.warehouse
  };
};

export { useLicensedProducts };
